import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { TrustedBy } from './components/sections/TrustedBy';
import { WorldClassTalent } from './components/sections/WorldClassTalent';
import { Testimonials } from './components/sections/Testimonials';
import { ExploreYourPath } from './components/sections/ExploreYourPath';
import { Footer } from './components/sections/Footer';
import { CaseStudyDetail } from './components/pages/CaseStudyDetail';
import { BookingPage } from './components/pages/BookingPage';
import { FractionalPM } from './components/pages/FractionalPM';
import { FractionalHeadOfAI } from './components/pages/FractionalHeadOfAI';
// Homepage - lean switchboard
const Home = () => {
  return <main data-id="element-0">
      <Hero data-id="element-1" />
      <TrustedBy data-id="element-2" />
      <WorldClassTalent data-id="element-3" />
      <Testimonials data-id="element-4" />
      <ExploreYourPath data-id="element-5" />
    </main>;
};
export function App() {
  return <BrowserRouter data-id="element-6">
      <div className="font-sans min-h-screen flex flex-col" data-id="element-7">
        <Navbar data-id="element-8" />
        <div className="flex-grow" data-id="element-9">
          <Routes data-id="element-10">
            <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
            <Route path="/fractional-pm" element={<FractionalPM data-id="element-14" />} data-id="element-13" />
            <Route path="/fractional-head-of-ai" element={<FractionalHeadOfAI data-id="element-16" />} data-id="element-15" />
            <Route path="/case-study/:id" element={<CaseStudyDetail data-id="element-18" />} data-id="element-17" />
            <Route path="/book-meeting" element={<BookingPage data-id="element-20" />} data-id="element-19" />
            {/* Catch-all route for unmatched URLs (e.g. from social media tracking params) */}
            <Route path="*" element={<Home data-id="element-22" />} data-id="element-21" />
          </Routes>
        </div>
        <Footer data-id="element-23" />
      </div>
    </BrowserRouter>;
}